import { render, staticRenderFns } from "./ContainerComponent.vue?vue&type=template&id=4a8100d2&scoped=true&"
import script from "./ContainerComponent.vue?vue&type=script&lang=js&"
export * from "./ContainerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContainerComponent.vue?vue&type=style&index=0&id=4a8100d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8100d2",
  null
  
)

export default component.exports